export function createInitialToastState() {
  return {
    show: false,
    message: "",
    type: "success",
    action: "info",
  };
}

export function createToastState(message, type = "success", action = "info") {
  return {
    show: true,
    message,
    type,
    action,
  };
}

export function hideToastState(prev) {
  return {
    ...prev,
    show: false,
  };
}
